import { mapActions, mapGetters } from 'vuex';
import Accordion from './components/accordion/index.vue'
import Feedback from './components/feedback/index.vue'
import {
    GET_FAQ_LIST
} from "@/store/action-types";
export default {
    name: 'faq',
    breadcrumb() {
        return {
            label: this.$t('faq'),
            parentsList: [
                {
                    path: '/',
                    label: this.$t('main'),
                    name: 'home'
                }
            ]
        }
    },
    data(){
        return{
            params: {
                title: '',
                description: '',
                keywords: '',
                image: ''
            },
        }
    },
    head: {
        meta: function () {
            let meta = [
                { n: 'description', c: this.params.description, id: 'description' },
                { n: 'keywords', c: this.params.keywords, id: 'keywords' },
                { n: 'og:title', c: this.params.title, id: 'og:title' },
                { n: 'og:description', c: this.params.description, id: 'og:description' },
            ]

            if (Object.keys(this.$route.query).length > 0) {
                meta.push({ n: 'robots', c: 'noindex, nofollow' })
                return meta
            } else {
                return meta
            }
        },
        link: function () {
            let route = this.$route.path
            return [
                { rel: 'canonical', href: window.location.origin + this.$route.path, id: 'canonical' },
            ]
        }
    },
    components: {
        Accordion,
        Feedback
    },
    computed:{
        ...mapGetters({
            list: 'faq/list'
        })
    },
    created(){
        this.fetchList();
    },
    methods: {
        ...mapActions({
            fetchList: `faq/${GET_FAQ_LIST}`
        })
    }
}
